import KeyValueListDisplay from '@/components/KeyValueDisplay';
import type { DeliveryDetailClientDetails } from '@/types/deliveryDetail.types';
import { convertISODateToMMDDYYYY, convertISOToTime } from '@/lib/utils';

export const ClientDetailsDeliveryContent = ({ data, isPrepaid }: { data: DeliveryDetailClientDetails | undefined; isPrepaid?: boolean }) => {
  if (!data) return null;

  const clientDetails = [
    { label: 'Case Name', value: data.caseName ?? '-' },
    { label: 'File/ Reference #', value: data.fileReferenceNumber ?? '-' },
    { label: "Client's Contact", value: data.clientContactName },
    { label: "Contact's Phone Number", value: data.contactPhone ?? '-' },
    { label: "Contact's Email Address", value: data.contactEmail ?? '-' },
    { label: "Prepaid", value: isPrepaid ? "Yes" : "No" },
    { label: 'Assigned User', value: data.assignedUser ?? '-' },
    { label: 'Service Type', value: data.serviceType },
    {
      label: 'Created By',
      value: (
        <div className="flex flex-col items-end">
          <span>{data.createdBy}</span>
          <span className="text-gray-500 text-xs">
            {convertISODateToMMDDYYYY(data.createdAt)} {convertISOToTime(data.createdAt)}
          </span>
        </div>
      ),
    },
    ...(data.modifiedBy ? [{
      label: 'Modified By',
      value: (
        <div className="flex flex-col items-end">
          <span>{data.modifiedBy}</span>
          {data.modifiedAt && (
            <span className="text-gray-500 text-xs">
              {convertISODateToMMDDYYYY(data.modifiedAt)} {convertISOToTime(data.modifiedAt)}
            </span>
          )}
        </div>
      ),
    }] : []),
  ];

  return (
    <div className="flex flex-col gap-4 w-full px-6 py-4">
      <div className="flex flex-col gap-2 w-full text-sm">
        <KeyValueListDisplay data={clientDetails} />
      </div>
    </div>
  );
};
